import * as React from 'react';

type Props = { className?: string };

function OneCredentialMigrateSuccessImage(_: Props) {
  return <></>;
}

export default OneCredentialMigrateSuccessImage;
